import $ from 'jquery';
import 'select2';

$('.client-category-select-single').select2();
$('.client-category-select-multiple').select2();

export function reloadScriptSelect2() {
    $('.client-category-select-single').select2();
    $('.client-category-select-multiple').select2();
}
